const startsWithSpreadsheetFormula = (text) => {
  let index = 0;
  while (index < text.length) {
    const codePoint = text.charCodeAt(index);
    const isControl = codePoint <= 32 || (codePoint >= 127 && codePoint <= 159);
    if (!isControl && !/\s/u.test(text[index])) break;
    index += 1;
  }
  return ['=', '+', '-', '@'].includes(text[index]);
};

export const neutralizeSpreadsheetCell = (value) => {
  const text = value === null || value === undefined ? '' : String(value);
  return startsWithSpreadsheetFormula(text) ? `'${text}` : text;
};

export const quoteCsvCell = (value) => {
  const safeText = neutralizeSpreadsheetCell(value);
  return `"${safeText.replace(/"/g, '""')}"`;
};
